<div class="main-container">
    <div class="content-container">
        <div class="header">
            <mat-icon
                class="read-all"
                matTooltip="Mark all as read"
                *ngIf="hasArchivables"
                (click)="archiveNotifications(allNotifications)"
            >
                visibility
            </mat-icon>
            <h2 class="title">
                <strong>Notifications</strong>
            </h2>
            <mat-icon class="close-button" matTooltip="Close" (click)="close()"
                >close</mat-icon
            >
        </div>

        <!-- Filter Tabs -->
        <mat-tab-group
            [(selectedIndex)]="selectedTabIndex"
            (selectedTabChange)="onTabChange($event)"
            animationDuration="200ms"
            class="notification-tabs"
        >
            <mat-tab label="All"></mat-tab>
            <mat-tab label="Unread"></mat-tab>
            <mat-tab label="Read"></mat-tab>
        </mat-tab-group>

        <div class="content">
            <mat-progress-bar
                *ngIf="loading"
                mode="indeterminate"
                aria-label="notifications progress"
            ></mat-progress-bar>
            <div
                *ngIf="!loading && !notifications.length"
                class="error-message"
            >
                <span *ngIf="!error; else errorMsg">No notifications.</span>
            </div>
            <mat-list role="list">
                <mat-list-item
                    class="boxed multi-line"
                    *ngFor="let notification of notifications"
                >
                    <mat-icon
                        [ngStyle]="readIcon"
                        *ngIf="notification.dateSeen == null"
                        (click)="archiveNotifications([notification])"
                        matTooltip="Mark as read"
                        matListItemIcon
                    >
                        visibility
                    </mat-icon>
                    <div matListItemTitle>
                        <span
                            class="unindent"
                            matTooltip="{{
                                notification.dateCreated
                                    | date: 'fullDate' : timeZone
                            }}"
                            [matTooltipShowDelay]="500"
                        >
                            {{
                                notification.dateCreated
                                    | date: "EEE 'at' h:mm a" : timeZone
                            }}
                        </span>
                        <mat-icon
                            class="info"
                            *ngIf="notification.comment"
                            [ngStyle]="commentIcon"
                            matListItemIcon
                        >
                            comment
                        </mat-icon>
                    </div>
                    <div
                        class="notification-content"
                        [innerHTML]="notification.rendered"
                        matListItemLine
                    ></div>
                    <div
                        class="comment-indent notification-comment"
                        *ngIf="notification.comment"
                        [innerHTML]="notification.comment"
                        matListItemLine
                    ></div>
                </mat-list-item>
            </mat-list>
        </div>
    </div>

    <div class="pagination-footer">
        <button
            mat-icon-button
            aria-label="Previous page"
            (click)="handlePagingClick(PageDirection.Left)"
            [disabled]="loading || page == 0"
        >
            <mat-icon>arrow_back</mat-icon>
        </button>
        <button
            mat-icon-button
            aria-label="Next page"
            (click)="handlePagingClick(PageDirection.Right)"
            [disabled]="loading || (page + 1) * pageSize >= total"
        >
            <mat-icon>arrow_forward</mat-icon>
        </button>
    </div>
</div>

<ng-template #errorMsg>
    <strong class="error"
        ><em>{{ error }}</em></strong
    >
</ng-template>
